import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { TwoFactorLoginComponent } from './two-factor-login/two-factor-login.component';
import { TwoFactorSetupComponent } from './two-factor-setup/two-factor-setup.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AuthenticationGuard } from 'app/shared/authentication/authentication-guard.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'login',
        component: LoginComponent,
        data: {
          title: 'Login'
        }
      },
      {
        path: 'two-factor-login',
        component: TwoFactorLoginComponent,
        data: {
          title: 'Two Factor Login'
        }
      },
      {
        path: 'two-factor-setup',
        component: TwoFactorSetupComponent,
        data: {
          title: 'Two Factor Setup'
        }
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
        data: {
          title: 'Change Password'
        },
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        data: {
          title: 'Forgot Password'
        }
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
        data: {
          title: 'Reset Password'
        }
      },
      {
        path: 'confirm-email',
        component: ConfirmEmailComponent,
        data: {
          title: 'Confirm Email'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule {
}
